// Access the strings used on the congratulations page.
export const t_congratulations = {
  title: "signup.congratulations.title",
  subtitle: "signup.congratulations.subtitle",
  bodyText: "signup.congratulations.bodyText",
  loginLink: "signup.congratulations.loginLink",
};
